// The button that folds the workspace sidebar to its icon rail or opens it
// again: in the sidebar's logo band and on the rail (CustomerSidebar), and
// in the Mac app in the window's top row (MacWindowControls).

import { useEffect, useRef } from "react";
import { PanelLeftClose, PanelLeftOpen } from "lucide-react";

import { Button } from "@/components/ui/Button";

// Folds the sidebar to its icon rail, or opens it again: a quiet icon
// button, the same size in both places, its name and key in the tooltip.
export function SidebarToggle({ collapsed, refocus, onToggle }: { collapsed: boolean; refocus: React.MutableRefObject<boolean>; onToggle: () => void }) {
  const ref = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!refocus.current) return;
    refocus.current = false;
    ref.current?.focus();
  }, [refocus]);
  const label = collapsed ? "Expand sidebar" : "Collapse sidebar";
  const Icon = collapsed ? PanelLeftOpen : PanelLeftClose;
  return (
    <Button
      ref={ref}
      variant="ghost"
      size="icon-sm"
      className="shrink-0"
      onClick={onToggle}
      aria-label={label}
      aria-keyshortcuts="["
      title={`${label} ([)`}
    >
      <Icon aria-hidden className="h-4 w-4" strokeWidth={1.75} />
    </Button>
  );
}
